package org.catharsis.spendtel.core.utils

import kotlin.random.Random

const val MAX_STATEMENT_FILE_SIZE_BYTES = 20 * 1024 * 1024L

fun sanitizeStatementFileName(fileName: String): String {
    val trimmed = fileName.trim().replace(Regex("[^a-zA-Z0-9._-]"), "_")
    return trimmed.take(120).ifEmpty { "statement.pdf" }
}

fun uniqueStatementStorageFileName(fileName: String): String {
    val sanitized = sanitizeStatementFileName(fileName)
    val dotIndex = sanitized.lastIndexOf('.')
    val base = if (dotIndex > 0) sanitized.substring(0, dotIndex) else sanitized
    val extension = if (dotIndex > 0) sanitized.substring(dotIndex) else ""
    val suffix = Random.nextLong().toULong().toString(16)
    return "${base}_$suffix$extension"
}

fun statementStorageLocation(userId: String, fileName: String): Pair<String, String> {
    val storageFileName = uniqueStatementStorageFileName(fileName)
    val storagePath = "users/$userId/statements/$storageFileName"
    return storagePath to storageFileName
}
